export default "__VITE_PUBLIC_ASSET__95fde476__"